<template>
  <div class="select">
    <span v-if="title" class="select__title">{{ title }} <span v-if="required" class="red">*</span></span>
    <Multiselect
      ref="multiselect" v-bind="$attrs" :options="options" :option-height="104" :placeholder="placeholder"
      :required="isRequired" :searchable="searchable" :internalSearch="internalSearch"
    >
      <template #noOptions>
        <span>Список пуст</span>
      </template>
      <template #placeholder>
        <span class="select__placeholder">{{ placeholder }}<span v-if="isRequired && !title"> *</span></span>
      </template>
      <template v-if="intervalLabel" #option="props">
        <span>{{ props.option.start }} - {{ props.option.end }}</span>
      </template>
      <template v-if="intervalLabel" #singleLabel="props">
        <span>{{ props.option.start }} - {{ props.option.end }}</span>
      </template>
      <template v-if="hiddenValue" #selection="{ values, isOpen }">
        <span v-if="values.length" v-show="!isOpen" class="multiselect__single">{{
          placeholder
        }}</span>
      </template>

      <template #noResult>
        <span>Не найдено</span>
      </template>
      <template v-if="searchable && !internalSearch" #afterList>
        <span class="multiselect__after-list">
          Не нашли нужное? Введите название в поле поиска
        </span>
      </template>
      <template #maxElements>
        Выбрано максимум доступных вариантов. Чтобы выбрать другой вариант, сначала удалите
        один из выбранных.
      </template>
      <template #caret="{ toggle }">
        <SvgIcon icon="chevron-down" class="caret" @mousedown.prevent.stop="toggle" />
      </template>
    </Multiselect>
    <div v-if="errorText" class="select__error">
      <span v-for="(error, index) in errorText" :key="index">{{ error }}</span>
    </div>
  </div>
</template>

<script lang="ts" src="./MultiselectElement.ts"></script>

<style lang="scss" src="./MultiselectElement.scss"></style>
